import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as ArrowDown } from 'assets/svg/icon-arrow-down.svg'

function IconArrowDown(props: IconProps): JSX.Element {
  const title = 'icon-arrow-down'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <ArrowDown {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconArrowDown
